import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import type { NotificationItemDto } from '@/api/notifications-client';
import { resolveNotificationTarget } from '@/lib/notification-presentation';

// =============================================================================
// use-notification-activate.ts — Activation d'une notification au clic (R15-COM-06, DBU D-2).
// =============================================================================
// Comportement PARTAGÉ par la cloche (volet) et le widget D-04. DBU D-2 : le clic NE MARQUE PLUS lu — il
// NAVIGUE SEULEMENT (résolution depuis `payloadContext` ; chat/annonces = pas de route V1 → aucune 404
// fabriquée). Le marquage lu est désormais un LOT AUTOMATIQUE à l'affichage du volet (clause système, DBU
// l.3252), porté par le volet lui-même — pas ici. Cibles typées explicitement (routes existantes) — pas de
// `to` dynamique non typé. Un callback optionnel `onNavigated` permet de fermer le volet (cible ou non).

export function useNotificationActivate(
  onActivated?: () => void,
): (item: NotificationItemDto) => void {
  const navigate = useNavigate();

  return React.useCallback(
    (item: NotificationItemDto): void => {
      const target = resolveNotificationTarget(item);
      onActivated?.();
      if (target === null) {
        return;
      }
      if (target.to === '/saisie/$submissionId') {
        const submissionId = target.params?.submissionId ?? '';
        const cycle = target.search?.['cycle'];
        void navigate({
          to: '/saisie/$submissionId',
          params: { submissionId },
          search: typeof cycle === 'number' ? { cycle } : {},
        });
        return;
      }
      if (target.to === '/campagnes') {
        const campaign = target.search?.['campaign'];
        void navigate({
          to: '/campagnes',
          search: typeof campaign === 'string' ? { campaign } : {},
        });
      }
    },
    [navigate, onActivated],
  );
}
